<template>
  <div class="sales-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <div class="shop-select">
            <ShopSelect :init="init" @updateShop="updateShop" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <el-button type="primary" @click="searchData">查询</el-button>
        </div>
      </div>
    </div>
    <Tablist
      :list="tabList"
      :active-id="activeIndex"
      @updateCurrentPage="updateCurrentPage"
    />
    <div v-if="activeIndex == 0" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售总览
          </div>
          <div class="data-count">
            <div class="flex-wrap">
              <div class="flex-con">
                <div class="order-count">
                  <span>销售总额</span>
                  <p class="bold">￥{{ totalData.sales_price1 }}</p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>退费总额</span>
                  <p class="bold">￥{{ totalData.sales_price2 }}</p>
                </div>
              </div>
              <div class="flex-con">
                <div class="order-count">
                  <span>总实收</span>
                  <p class="bold">
                    ￥{{ totalData.sales_price1 - totalData.sales_price2 }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售趋势<span
              style="font-size:16px !important"
            >（以下数据为所选时间段内包含的人工月数据）</span>
          </div>
          <Pie :title="'销售总额(￥)'" :query-data.sync="salesData1" />
          <Pie :title="'总实收(￥)'" :query-data.sync="salesData2" />
        </div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <div class="color-black data-title">
            销售趋势
          </div>
          <DataLine
            :title="'销售总额'"
            :echarts-data.sync="echartsData"
            :name="'sales_price7,sales_price8'"
            :legend="'新签,续费'"
          />
          <DataLine
            :title="'退费总额'"
            :echarts-data.sync="echartsData"
            :name="'sales_price2'"
            :legend="'退费总额'"
          />
        </div>
      </div>
    </div>
    <div v-if="activeIndex == 1" class="dataTable1">
      <div class="tuolele-main-box data-type-content">
        <el-table :data="dataList" max-height="800px">
          <el-table-column
            prop="shop_name"
            label="店铺"
            width="150px"
            fixed
          />
          <el-table-column label="签约">
            <el-table-column label="总计">
              <el-table-column label="销售总额">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="总实收">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price3 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="销售总额(不含体验)">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price6 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="总实收(不含体验)">
                <template slot-scope="scope">
                  <span>￥{{
                    scope.row.sales_price6 - scope.row.sales_price2
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="新签">
              <el-table-column label="新签总额">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price7 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="新签实收">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price10 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="新签人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.sales_price13 }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="续费">
              <el-table-column label="续费总额">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price8 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="续费实收">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price11 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="续费人数">
                <template slot-scope="scope">
                  <span>{{ scope.row.sales_price14 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="续费平均单笔金额">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.sales_price14"
                  >￥{{
                    (
                      scope.row.sales_price8 / scope.row.sales_price14
                    ).toFixed(2)
                  }}</span>
                  <span v-else>￥0</span>
                </template>
              </el-table-column>
              <el-table-column label="日均续费人数">
                <template slot-scope="scope">
                  <span>{{
                    (
                      scope.row.sales_price14 / statisticsData.natural_days
                    ).toFixed(1)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="日均续费金额">
                <template slot-scope="scope">
                  <span>￥{{
                    (
                      scope.row.sales_price8 / statisticsData.natural_days
                    ).toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="体验">
              <el-table-column label="体验总额">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.sales_price12 }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table-column>
          <el-table-column label="退费">
            <el-table-column label="退费总额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.sales_price2 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="退费人数(流失)">
              <template slot-scope="scope">
                <span>{{ scope.row.sales_price15 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="退费人次">
              <template slot-scope="scope">
                <span>{{ scope.row.sales_price16 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="日均退费人数(流失)">
              <template slot-scope="scope">
                <span>{{
                  (
                    scope.row.sales_price15 / statisticsData.natural_days
                  ).toFixed(1)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="日均退费人次">
              <template slot-scope="scope">
                <span>{{
                  (
                    scope.row.sales_price16 / statisticsData.natural_days
                  ).toFixed(1)
                }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div v-if="activeIndex == 2" class="dataTable1">
      <div>
        <div class="tuolele-main-box chart-body flex-wrap">
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'销售总额'"
            :show-keys="barKeys1"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'退费总额'"
            :show-keys="barKeys2"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'新签总额'"
            :show-keys="barKeys3"
            :query-data.sync="dataInfo"
          />
          <HorizontalBar
            class="horizontal-bar"
            height="520"
            :title="'续费总额'"
            :show-keys="barKeys4"
            :query-data.sync="dataInfo"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShopSelect from '@/components/toolbar/ShopSelect.vue'
import Tablist from '@/components/toolbar/Tablist.vue'
import DataLine from '@/components/chart/DataLine.vue'
import HorizontalBar from '@/components/chart/HorizontalBar.vue'
import Pie from '@/components/chart/Pie.vue'
import Tool from '@/assets/js/tool.js'
export default {
  name: 'CampusStatistics',
  components: {
    ShopSelect,
    Tablist,
    DataLine,
    HorizontalBar,
    Pie
  },
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '',
        search_calendar: '',
        key:
          'D6,D7,D8,D9,D10,D11,D12,D14,F2,F4,E4,L2,L4,M2,M4,K5,K6,L2,M2,C6,C7,C8,C9,C10,C11,C12'
      },
      selectDays: '0',
      tabList: [
        { id: '0', directory_name: '总览数据' },
        { id: '1', directory_name: '详细数据' },
        { id: '2', directory_name: '店铺对比数据' }
      ],
      activeIndex: '0',
      statisticsData: {},
      init: true,
      dataInfo: [],
      echartsData: [],
      totalData: {},
      salesData1: [],
      salesData2: [],
      attrArr: [
        // 销售总览统计
        { key: 'sales_price1', attrs: 'D6+D7+D8+D9+D10+D11+D12+D14+F4+E4' }, // 销售总额
        { key: 'sales_price2', attrs: 'L4+M4' }, // 退费总额
        { key: 'sales_price3', attrs: '' }, // 总实收 D6+D7+D8+D9+D10+D11+D12+F4+E4-L4-M4
        { key: 'sales_price4', attrs: 'L4' }, //
        { key: 'sales_price5', attrs: 'M4' }, // 续费退费
        { key: 'sales_price6', attrs: 'D6+D7+D8+D9+D10+D11+D12+F4' }, // 销售总额（不含体验）
        { key: 'sales_price7', attrs: 'D6+D7+D8+D9+D10+D11+D12+D14' }, // 新签总额
        { key: 'sales_price8', attrs: 'F4' }, // 续费总额
        { key: 'sales_price9', attrs: 'E4' }, // 体验总额
        { key: 'sales_price10', attrs: '' }, // 新签实收  D6+D7+D8+D9+D10+D11+D12-L4
        { key: 'sales_price11', attrs: '' }, // 续费实收  F4-M4
        { key: 'sales_price12', attrs: 'E4' }, // 体验实收
        { key: 'sales_price13', attrs: 'C6+C7+C8+C9+C10+C11+C12' }, // 新签人数
        { key: 'sales_price14', attrs: 'F2' }, // 续费人数
        { key: 'sales_price15', attrs: 'K5+K6' }, // 退费人数
        { key: 'sales_price16', attrs: 'L2+M2' } // 退费人次
      ],
      barKeys1: [
        { key: 'sales_price3', name: '实收', color: '#4c84ff' },
        { key: 'sales_price1', name: '销售总额', color: '#34c6ac' }
      ],
      barKeys2: [{ key: 'sales_price2', name: '退费总额', color: '#4c84ff' }],
      barKeys3: [
        { key: 'sales_price10', name: '实收', color: '#4c84ff' },
        { key: 'sales_price7', name: '新签总额', color: '#34c6ac' }
      ],
      barKeys4: [
        { key: 'sales_price11', name: '实收', color: '#4c84ff' },
        { key: 'sales_price8', name: '续费总额', color: '#34c6ac' }
      ],
      dataList: []
    }
  },
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
  },
  methods: {
    getDataForShop() {
      this.$http.getDataForShop(this.filterObj).then(res => {
        if (res.code == 200) {
          this.statisticsData = res.data
          const dataInfo = res.data.shop_data
          dataInfo.unshift({
            shop_name: '总和',
            result: res.data.total_data
          })
          dataInfo.forEach(e => {
            // for (const key in e.result) {
            //   if (['D6','D7','D8','D9','D10','D11','D12','F4','E4','L4','M4'].indexOf(key) > -1) {
            //     e.result[key] = ((e.result[key])/100).toFixed(2);
            //   }
            // }
            Tool.formateData(this.attrArr, e)
            e.sales_price1 = e.sales_price1 / (100).toFixed(2)
            e.sales_price2 = e.sales_price2 / (100).toFixed(2)
            e.sales_price4 = e.sales_price4 / (100).toFixed(2)
            e.sales_price5 = e.sales_price5 / (100).toFixed(2)
            e.sales_price6 = e.sales_price6 / (100).toFixed(2)
            e.sales_price7 = e.sales_price7 / (100).toFixed(2)
            e.sales_price8 = e.sales_price8 / (100).toFixed(2)
            e.sales_price9 = e.sales_price9 / (100).toFixed(2)
            e.sales_price12 = e.sales_price12 / (100).toFixed(2)
            e.sales_price3 = e.sales_price1 - e.sales_price2
            e.sales_price10 = e.sales_price7 - e.sales_price4
            e.sales_price11 = e.sales_price8 - e.sales_price5
          })
          this.dataInfo = dataInfo.slice(1)
          this.dataList = dataInfo
          this.totalData = {
            result: res.data.total_data
          }
          // for (const key in this.totalData.result) {
          //   if (['D6','D7','D8','D9','D10','D11','D12','F4','E4','L4','M4'].indexOf(key) > -1) {
          //     this.totalData.result[key] = ((this.totalData.result[key])/100).toFixed(2);
          //   }
          // }
          Tool.formateData(this.attrArr, this.totalData)
          this.totalData.sales_price1 =
            this.totalData.sales_price1 / (100).toFixed(2)
          this.totalData.sales_price2 =
            this.totalData.sales_price2 / (100).toFixed(2)
          this.totalData.sales_price4 =
            this.totalData.sales_price4 / (100).toFixed(2)
          this.totalData.sales_price5 =
            this.totalData.sales_price5 / (100).toFixed(2)
          this.totalData.sales_price6 =
            this.totalData.sales_price6 / (100).toFixed(2)
          this.totalData.sales_price7 =
            this.totalData.sales_price7 / (100).toFixed(2)
          this.totalData.sales_price8 =
            this.totalData.sales_price8 / (100).toFixed(2)
          this.totalData.sales_price9 =
            this.totalData.sales_price9 / (100).toFixed(2)
          this.totalData.sales_price12 =
            this.totalData.sales_price12 / (100).toFixed(2)

          this.salesData1 = [
            {
              value: this.totalData.sales_price7,
              key: '0',
              name: '新签总额',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.totalData.sales_price9,
              key: '1',
              name: '体验总额',
              itemStyle: { color: '#4ac634' }
            },
            {
              value: this.totalData.sales_price8,
              key: '2',
              name: '续费总额',
              itemStyle: { color: '#ffb34c' }
            }
          ]
          this.salesData2 = [
            {
              value: this.totalData.sales_price7 - this.totalData.sales_price4,
              key: '0',
              name: '新签实收',
              itemStyle: { color: '#4c84ff' }
            },
            {
              value: this.totalData.sales_price9,
              key: '1',
              name: '体验实收',
              itemStyle: { color: '#4ac634' }
            },
            {
              value: this.totalData.sales_price8 - this.totalData.sales_price5,
              key: '2',
              name: '续费实收',
              itemStyle: { color: '#ffb34c' }
            }
          ]
        }
      })
      this.$http.getDataForShopByDate(this.filterObj).then(res => {
        if (res.code == 200) {
          const echartsData = res.data
          echartsData.forEach(e => {
            e.result = e.value
            // for (const key in e.result) {
            //   if (['D6','D7','D8','D9','D10','D11','D12','F4','E4','L4','M4'].indexOf(key) > -1) {
            //     e.result[key] = ((e.result[key])/100).toFixed(2);
            //   }
            // }
            Tool.formateData(this.attrArr, e)
            e.sales_price1 = e.sales_price1 / (100).toFixed(2)
            e.sales_price2 = e.sales_price2 / (100).toFixed(2)
            e.sales_price4 = e.sales_price4 / (100).toFixed(2)
            e.sales_price5 = e.sales_price5 / (100).toFixed(2)
            e.sales_price6 = e.sales_price6 / (100).toFixed(2)
            e.sales_price7 = e.sales_price7 / (100).toFixed(2)
            e.sales_price8 = e.sales_price8 / (100).toFixed(2)
            e.sales_price9 = e.sales_price9 / (100).toFixed(2)
            e.sales_price12 = e.sales_price12 / (100).toFixed(2)
            e.sales_price3 = e.sales_price1 - e.sales_price2
            e.sales_price10 = e.sales_price7 - e.sales_price4
            e.sales_price11 = e.sales_price8 - e.sales_price5
          })
          this.echartsData = echartsData
          console.log(this.echartsData)
        }
      })
    },
    updateCurrentPage(val) {
      this.activeIndex = val
    },
    updateShop(val) {
      this.filterObj.shop_id = val.join(',')
      if (this.init) {
        this.init = false
        this.getDataForShop(this.filterObj)
      }
    },
    searchData() {
      this.getDataForShop(this.filterObj)
    }
  }
}
</script>
<style lang="scss">
.sales-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
  .search-box {
    margin-top: 20px;
  }
  .el-form-item {
    display: block;
    .el-input {
      width: 150px;
      margin-left: 30px;
      margin-right: 20px;
    }
    .el-form-item__content {
      width: 90%;
    }
  }
  .date-box {
    display: inline;
  }
  .chart-body {
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .data-title {
    display: block;
    width: 100%;
    font-size: 24px;
    margin-bottom: 30px;
  }
  .checkbox-item:first-child {
    width: 80px !important;
    margin-bottom: 20px;
  }
  .checkbox-item {
    width: 160px !important;
    margin-bottom: 20px;
  }
  .compare-data {
    margin-bottom: 50px;
    width: 760px;
    .title {
      color: black;
      font-size: 24px;
      margin-bottom: 20px;
    }
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .data-count {
    width: 100%;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 15px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .horizontal-bar {
    width: 760px;
  }
  .data-type-content {
    padding-top: 40px;
    margin-bottom: 50px;
  }
}
</style>
